import { MAIL_TEMPLATE } from './mail-template'

export const PARTNER = `{
  id
  name
  display_name
  authorized_create
  authorized_read
  authorized_update
  career_site_url
  aivy_form_id
  planned_new_hires_per_year
  app_settings {
    components
    application_input_additional_fields
    challenges
    report_settings
    report_v1_settings
    report_v2_settings
    dashboard_settings
    cultural_fit
    mail_template ${MAIL_TEMPLATE}
    mail_template_reminder ${MAIL_TEMPLATE}
    mail_template_reject ${MAIL_TEMPLATE}
    assessment_expires_after_days
    automations
  }
  logo
  lead_ampel
  createdAt
  updatedAt
}`
